//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Item',
  name: 'sierra-asset',
  knittingMachineCategoryId: '673c07b2a128eab872eb6c2d',
  finishingAssetCategory: '67fdbaa6f37a22aafe95f6e0',
  doubleKnitAssetTypeId: '67acdba2ee06eac3505f985f',
  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    financeApi: 'https://finance.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
  featureFlags: {
    // GL Accounts section in the Item Master modal. Hidden in prod for now.
    itemMasterGlAccounts: true,
  },
};
